import { apiClient } from "@/lib/api/client";

export type ExternalDeviceApiKeyDto = {
  id: string;
  tenant_id: string | null;
  device_id: string | null;
  created_by_user_id: string | null;
  created_by_name: string | null;
  created_by_email: string | null;
  name: string | null;
  key_prefix: string | null;
  scopes: string[];
  created_at: string | null;
  last_used_at: string | null;
  revoked_at: string | null;
};

export type ExternalDeviceApiKeyCreatedDto = ExternalDeviceApiKeyDto & {
  key: string;
};

export type ExternalDeviceApiKeyListResponse = {
  items: ExternalDeviceApiKeyDto[];
  total: number;
  page: number;
  page_size: number;
};

export async function listExternalDeviceApiKeys(
  deviceId: string,
  options: { search?: string; page?: number; pageSize?: number } = {},
): Promise<ExternalDeviceApiKeyListResponse> {
  const params: Record<string, string | number> = {};
  if (options.search?.trim()) params.search = options.search.trim();
  if (options.page != null) params.page = options.page;
  if (options.pageSize != null) params.page_size = options.pageSize;
  const { data } = await apiClient.get<ExternalDeviceApiKeyListResponse>(`/api-keys/devices/${deviceId}`, { params });
  return data;
}

export async function createExternalDeviceApiKey(
  deviceId: string,
  body: { name: string; scopes: string[] },
): Promise<ExternalDeviceApiKeyCreatedDto> {
  const { data } = await apiClient.post<ExternalDeviceApiKeyCreatedDto>(`/api-keys/devices/${deviceId}`, body);
  return data;
}

export async function deleteExternalDeviceApiKey(deviceId: string, keyId: string): Promise<void> {
  await apiClient.delete(`/api-keys/devices/${deviceId}/${keyId}`);
}
